<template>
  <VWidget content-class="pa-0">
    <template slot="title">{{ $t('title') }}</template>
    <template slot="header-actions">
      <v-btn icon small @click="editOrganization" v-if="$organization.isAllowed('update', currentOrg)">
        <v-icon small>{{ $vuetify.icons.values.edit }}</v-icon>
      </v-btn>
    </template>
    <template slot="content">
      <v-alert v-model="warning" dismissible type="error">{{ warningMessage }}.</v-alert>
      <v-list>
        <v-list-item class="py-1">
          <v-list-item-content>
            <v-list-item-subtitle>{{ $t('displayName') }}</v-list-item-subtitle>
            <v-list-item-title v-if="currentOrg">
              {{ currentOrg.display }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
      </v-list>
    </template>
  </VWidget>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { VWidget } from '@argon/app/components'
import { NAMESPACE } from '../store'
import organizationPerimeter from '../perimeters'

export default {
  name: 'OrgProperties',
  components: {
    VWidget
  },
  perimeters: [organizationPerimeter],
  data: () => ({
    warning: false,
    warningMessage: ''
  }),
  computed: {
    ...mapState(NAMESPACE, ['currentOrg'])
  },
  methods: {
    editOrganization() {
      this.$router.push({ name: 'editOrganization' })
    }
  }
}
</script>

<style scoped lang="scss">
.list-section {
  margin-bottom: 25px;
}
</style>

<i18n>
{
  "en": {
    "displayName": "@:labels.displayName",
    "edit": "@:labels.edit",
    "title": "@:labels.properties"
  },
  "fr": {
    "displayName": "@:labels.displayName",
    "edit": "@:labels.edit",
    "title": "@:labels.properties"
  }
}
</i18n>
